import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from '@mui/material';
import CustomTextField from 'components/mui/text-field';

const AddSalesTaxDialog = ({ open, handleClose, onSave, editingTax }) => {
  const [county, setCounty] = useState('');
  const [rate, setRate] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setErrors({});

    if (editingTax) {
      setCounty(editingTax.county || '');
      setRate(editingTax.rate?.toString() || '');
    } else {
      setCounty('');
      setRate('');
    }
  }, [editingTax, open]);

  const handleSave = () => {
  const newErrors = {};

  if (!county) {
    newErrors.county = 'County Name is required.';
  } else if (county.trim().length < 2) {
    newErrors.county = 'County Name should be at least 2 characters.';
  }

  if (!rate) {
    newErrors.rate = 'Tax Rate is required.';
  }

  setErrors(newErrors);
  if (Object.keys(newErrors).length) return;

  const tax = {
    salesTaxID: editingTax?.salesTaxID || 0,
    county,
    rate: parseFloat(rate),
    isActive: true,
  };

  // pass isEdit flag
  onSave(tax, !!editingTax);
  handleClose();
};

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle
        sx={{
          borderBottom: '1px solid #D9D9D9',
          paddingBottom: '20px !important',
        }}
      >
        <Typography variant="h4" fontWeight="bold">
          {editingTax ? 'Edit Sales Tax' : 'Add Tax Rate'}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={5}>
          <Grid item xs={12} md={6.5}>
            <CustomTextField
              fullWidth
              required
              label="County"
              placeholder="Enter county name"
              value={county}
              onChange={(e) => {
                setCounty(e.target.value);
                setErrors(prev => ({ ...prev, county: undefined }));
              }}
              error={!!errors.county}
              helperText={errors.county}
            />
          </Grid>
          <Grid item xs={12} md={6.5}>
            <CustomTextField
              required            
              fullWidth
              label="Tax Rate (%)"
              placeholder="Enter tax rate percentage"
              value={rate}
              onChange={(e) => {
                const input = e.target.value;
                let filtered = '';
                let digitCount = 0;
                let dotAdded = false;

                for (const ch of input) {
                  if (/\d/.test(ch)) {
                    if (digitCount < 4) {
                      filtered += ch;
                      digitCount++;
                    }
                  } else if (ch === '.' && !dotAdded) {
                    filtered += ch;
                    dotAdded = true;
                  }
                }

                setRate(filtered);
                setErrors(prev => ({ ...prev, rate: undefined }));
              }}
              inputProps={{
                inputMode: 'decimal',
                pattern: '[0-9]*\\.?[0-9]*'
              }}
              error={!!errors.rate}
              helperText={errors.rate}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '20px 24px !important',
          boxShadow: '0px -4px 8px rgb(0 0 0 / 10%)',
          zIndex: 1,
        }}
        className="dialog-actions-dense"
      >
        <Box>
          <Button variant="contained" color="info" onClick={handleClose}>
            Cancel
          </Button>
        </Box>
        <Box>
          <Button variant="contained" color="main" onClick={handleSave}>
            {editingTax ? 'Save Changes' : 'Save Tax Rate'}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default AddSalesTaxDialog;